export default {
  options: { customProperties: true },
  themes: {
    light: {
      primary: {
        base: "#000091",
        lighten5: "#e0e0f2",
        lighten4: "#cacafb",
        lighten3: "#8080c8",
        lighten2: "#4d4db2",
        lighten1: "#2626a2",
        darken1: "#000089",
        darken2: "#00007e",
        darken3: "#000074",
        darken4: "#000062",
      },
      secondary: {
        base: "#ce614a",
        lighten5: "#f9ece9",
        lighten4: "#f0d0c9",
        lighten3: "#e7b0a5",
        lighten2: "#dd9080",
        lighten1: "#d57965",
        darken1: "#c95943",
        darken2: "#c24f3a",
        darken3: "#bc4532",
        darken4: "#b03322",
      },
      error: "#df3232",
    },
  },
}
